import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

export default function SideContent({children}) {
  return <nav className={styles.root}>{children}</nav>
}

SideContent.propTypes = {
  children: PropTypes.node
}
